export const FormNames = {
  billingAddress: 'billingAddress',
  shippingAddress: 'shippingAddress',
  consentGroup: 'consentGroup',
  contactDetails: 'contactDetails',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/formNames.ts